import { useSyncExternalStore } from 'react';
import { deviceZone } from './zones';

// The viewer's time zone (TF-220): the one fixed in My account, else the device's (Automatic). Every
// time in the app is shown in it. Kept outside React so formatters and API calls read it too; the
// components that show times follow it through useViewerZone().

let fixed: string | null = null;
const listeners = new Set<() => void>();

/** The zone times are shown in now. */
export function viewerZone(): string {
  return fixed ?? deviceZone();
}

/** The zone fixed in My account, or null for Automatic (the device's). */
export function setFixedZone(zone: string | null): void {
  if (zone === fixed) return;
  fixed = zone;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useViewerZone(): string {
  return useSyncExternalStore(subscribe, viewerZone, viewerZone);
}

let company: string | null = null;

/** The zone of the company open now (its setting, else its country's): suggested when a zone is chosen. */
export const companyZone = () => company;

export function setCompanyZone(zone: string | null): void {
  company = zone;
}
